// extracted by mini-css-extract-plugin
export default {"alert":"fg","centered":"gg","message":"hg","shrink":"ig","error":"jg","warn":"kg","info":"lg","success":"mg","icon":"ng","contents":"og","actions":"pg","alertAction":"qg"};